var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _g2, _g3, _g4, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCapfooterlogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 79,
    viewBox: "0 0 300 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8619 49.5421H41.4839V25.4229H46.8619V49.5421Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7088 32.2311C82.7088 33.4626 82.5571 34.5627 82.2537 35.5314C81.9503 36.5 81.5366 37.358 81.0126 38.1052C80.5024 38.8386 79.9094 39.4682 79.2337 39.9941C78.558 40.5199 77.8478 40.9489 77.1032 41.281C76.3723 41.6131 75.6277 41.8552 74.8692 42.0075C74.1246 42.1597 73.4213 42.2358 72.7594 42.2358H60.5967V36.8391H72.7594C73.4489 36.7837 74.0694 36.6453 74.621 36.4239C75.1864 36.1887 75.669 35.8773 76.0689 35.4899C76.4688 35.1024 76.7791 34.6388 76.9998 34.0992C77.2204 33.5457 77.3307 32.923 77.3307 32.2311V29.7818C77.2618 29.1037 77.117 28.481 76.8963 27.9137C76.6757 27.3463 76.3723 26.862 75.9862 26.4607C75.6139 26.0594 75.1588 25.7481 74.621 25.5267C74.0832 25.2914 73.4626 25.1738 72.7594 25.1738H60.638C59.921 25.1738 59.3763 25.3606 59.0039 25.7342C58.6316 26.1079 58.4455 26.6475 58.4455 27.3533V49.5421H53.0674V27.3533C53.0674 25.9695 53.3156 24.7933 53.812 23.8246C54.3223 22.856 54.9497 22.0741 55.6944 21.4791C56.4528 20.8841 57.2733 20.4551 58.1559 20.1922C59.0384 19.9155 59.852 19.7771 60.5967 19.7771H72.7594C73.9729 19.7771 75.0623 19.9362 76.0276 20.2545C76.9929 20.5589 77.8409 20.974 78.5718 21.4999C79.3165 22.0119 79.9439 22.6069 80.4541 23.285C80.9781 23.963 81.4056 24.6756 81.7366 25.4229C82.0813 26.1563 82.3295 26.9035 82.4812 27.6646C82.6329 28.4118 82.7088 29.1176 82.7088 29.7818V32.2311Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.337 49.5421H98.9348C98.4384 49.5421 97.9005 49.4868 97.3214 49.3761C96.756 49.2515 96.1906 49.0647 95.6252 48.8156C95.0736 48.5666 94.5427 48.2483 94.0325 47.8608C93.5223 47.4595 93.0672 46.9821 92.6673 46.4286C92.2812 45.8613 91.9709 45.2109 91.7365 44.4775C91.502 43.7303 91.3848 42.8931 91.3848 41.9659V27.3533C91.3848 26.8551 91.44 26.3223 91.5503 25.755C91.6744 25.1738 91.8606 24.6065 92.1088 24.0529C92.357 23.4856 92.6811 22.9459 93.081 22.4339C93.4809 21.9219 93.9566 21.4722 94.5082 21.0847C95.0736 20.6835 95.7217 20.3652 96.4526 20.1299C97.1835 19.8947 98.0109 19.7771 98.9348 19.7771H118.337V25.1738H98.9348C98.2315 25.1738 97.6937 25.3606 97.3214 25.7342C96.949 26.1079 96.7629 26.6614 96.7629 27.3948V41.9659C96.7629 42.6578 96.949 43.1975 97.3214 43.585C97.7075 43.9586 98.2453 44.1454 98.9348 44.1454H118.337V49.5421Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152.529 49.5421H147.151V42.2358H128.245V49.5421H122.867V34.6596C122.867 32.4871 123.239 30.4875 123.984 28.6609C124.729 26.8343 125.763 25.2638 127.087 23.9492C128.411 22.6346 129.976 21.6106 131.782 20.8772C133.589 20.1438 135.561 19.7771 137.698 19.7771H149.819C150.192 19.7771 150.543 19.8463 150.874 19.9846C151.205 20.123 151.495 20.3167 151.743 20.5658C151.991 20.8149 152.184 21.1055 152.322 21.4376C152.46 21.7697 152.529 22.1226 152.529 22.4962V49.5421ZM128.245 36.8391H147.151V25.1738H137.698C137.533 25.1738 137.181 25.2015 136.643 25.2568C136.119 25.2983 135.506 25.416 134.802 25.6097C134.113 25.8034 133.382 26.1009 132.61 26.5022C131.837 26.9035 131.127 27.457 130.479 28.1628C129.831 28.8685 129.293 29.7541 128.866 30.8196C128.452 31.8713 128.245 33.1513 128.245 34.6596V36.8391Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M188.355 32.2311C188.355 33.4626 188.204 34.5627 187.9 35.5314C187.597 36.5 187.183 37.358 186.659 38.1052C186.149 38.8386 185.556 39.4682 184.88 39.9941C184.205 40.5199 183.494 40.9489 182.75 41.281C182.019 41.6131 181.274 41.8552 180.516 42.0075C179.771 42.1597 179.068 42.2358 178.406 42.2358H172.325V36.8391H178.406C179.095 36.7837 179.716 36.6453 180.268 36.4239C180.833 36.1887 181.316 35.8773 181.716 35.4899C182.115 35.1024 182.426 34.6388 182.646 34.0992C182.867 33.5457 182.977 32.923 182.977 32.2311V29.7818C182.908 29.1037 182.764 28.481 182.543 27.9137C182.322 27.3463 182.019 26.862 181.633 26.4607C181.26 26.0594 180.805 25.7481 180.268 25.5267C179.73 25.2914 179.109 25.1738 178.406 25.1738H166.285C165.568 25.1738 165.023 25.3606 164.651 25.7342C164.278 26.1079 164.092 26.6475 164.092 27.3533V49.5421H158.714V27.3533C158.714 25.9695 158.962 24.7933 159.459 23.8246C159.969 22.856 160.596 22.0741 161.341 21.4791C162.099 20.8841 162.92 20.4551 163.802 20.1922C164.685 19.9155 165.499 19.7771 166.243 19.7771H178.406C179.619 19.7771 180.709 19.9362 181.674 20.2545C182.639 20.5589 183.488 20.974 184.218 21.4999C184.963 22.0119 185.59 22.6069 186.101 23.285C186.625 23.963 187.052 24.6756 187.383 25.4229C187.728 26.1563 187.976 26.9035 188.128 27.6646C188.279 28.4118 188.355 29.1176 188.355 29.7818V32.2311Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M219.776 25.1738H207.923V49.5421H202.545V25.1738H190.672V19.7771H219.776V25.1738Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M251.816 49.5421H246.438V42.2358H227.532V49.5421H222.154V34.6596C222.154 32.4871 222.527 30.4875 223.271 28.6609C224.016 26.8343 225.05 25.2638 226.374 23.9492C227.698 22.6346 229.263 21.6106 231.07 20.8772C232.876 20.1438 234.848 19.7771 236.985 19.7771H249.107C249.479 19.7771 249.831 19.8463 250.162 19.9846C250.493 20.123 250.782 20.3167 251.03 20.5658C251.279 20.8149 251.472 21.1055 251.61 21.4376C251.747 21.7697 251.816 22.1226 251.816 22.4962V49.5421ZM227.532 36.8391H246.438V25.1738H236.985C236.82 25.1738 236.468 25.2015 235.93 25.2568C235.406 25.2983 234.793 25.416 234.09 25.6097C233.4 25.8034 232.669 26.1009 231.897 26.5022C231.125 26.9035 230.415 27.457 229.766 28.1628C229.118 28.8685 228.58 29.7541 228.153 30.8196C227.739 31.8713 227.532 33.1513 227.532 34.6596V36.8391Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M263.503 49.5421H258.125V23.9492H263.503V49.5421Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M299.433 47.2381C299.433 47.6256 299.357 47.9854 299.205 48.3175C299.068 48.6496 298.874 48.9402 298.626 49.1893C298.392 49.4245 298.109 49.6113 297.778 49.7497C297.447 49.8881 297.096 49.9573 296.723 49.9573C296.392 49.9573 296.054 49.895 295.71 49.7704C295.379 49.6459 295.082 49.4453 294.82 49.1685L275.17 28.5779V49.5421H269.792V22.0811C269.792 21.5276 269.943 21.0294 270.247 20.5866C270.564 20.1299 270.964 19.7909 271.446 19.5695C271.957 19.3619 272.481 19.3135 273.018 19.4242C273.556 19.5211 274.018 19.7702 274.404 20.1715L294.055 40.7413V19.7771H299.433V47.2381Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3365_4240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.8481 44.5667C81.8481 44.3162 82.0513 44.113 82.3018 44.113H86.92C87.1706 44.113 87.3737 44.3162 87.3737 44.5667V49.2041C87.3737 49.4546 87.1706 49.6578 86.92 49.6578H82.3018C82.0513 49.6578 81.8481 49.4546 81.8481 49.2041V44.5667Z",
    fill: "#66C16D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3365_4240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.068 17.3538C258.068 17.1033 258.271 16.9001 258.522 16.9001H263.14C263.39 16.9001 263.593 17.1033 263.593 17.3538V21.9912C263.593 22.2418 263.39 22.4449 263.14 22.4449H258.522C258.271 22.4449 258.068 22.2418 258.068 21.9912V17.3538Z",
    fill: "#66C16D"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3365_4240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.6536 18.2779C41.6536 18.0273 41.8567 17.8242 42.1073 17.8242H46.7254C46.976 17.8242 47.1791 18.0273 47.1791 18.2779V22.9153C47.1791 23.1658 46.976 23.369 46.7254 23.369H42.1073C41.8567 23.369 41.6536 23.1658 41.6536 22.9153V18.2779Z",
    fill: "#66C16D"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3365_4240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.06 37.2235C165.06 36.9729 165.263 36.7698 165.514 36.7698H170.132C170.382 36.7698 170.586 36.9729 170.586 37.2235V41.8608C170.586 42.1114 170.382 42.3145 170.132 42.3145H165.514C165.263 42.3145 165.06 42.1114 165.06 41.8608V37.2235Z",
    fill: "#66C16D"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5104 37.1436C14.7916 36.8863 15.2446 37.0858 15.2446 37.467V49.5608C15.2446 49.8028 15.0484 49.9991 14.8063 49.9991H1.59197C1.19207 49.9991 1.00105 49.5074 1.29606 49.2374L14.5104 37.1436Z",
    fill: "#66C16D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2682 37.1314C17.9862 36.8772 17.5364 37.0773 17.5364 37.4569V49.5608C17.5364 49.8028 17.7326 49.9991 17.9747 49.9991H31.4012C31.8027 49.9991 31.9929 49.5041 31.6947 49.2352L18.2682 37.1314Z",
    fill: "#66C16D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22611 39.4557C8.31635 39.3727 8.3677 39.2557 8.3677 39.1331L8.3677 11.6091C8.3677 11.2311 7.92135 11.0304 7.63859 11.2812L0.650173 17.4791C0.556383 17.5623 0.5027 17.6816 0.5027 17.807L0.502699 45.5606C0.502699 45.9423 0.956749 46.1416 1.2377 45.8832L8.22611 39.4557Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7842 5.7778C10.6859 5.86107 10.6292 5.9834 10.6292 6.11224L10.6292 21.6255C10.6292 21.9987 11.0659 22.2012 11.3508 21.9599L16.1305 17.9115C16.2986 17.7691 16.5463 17.7737 16.7091 17.9221L21.0721 21.9019C21.3535 22.1586 21.8058 21.9589 21.8058 21.5781L21.8058 6.10254C21.8058 5.97931 21.7539 5.86177 21.6628 5.77873L16.7091 1.26014C16.5463 1.11165 16.2986 1.10709 16.1305 1.24951L10.7842 5.7778Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4164 39.4565C24.3211 39.3732 24.2665 39.2529 24.2665 39.1264L24.2665 12.3663C24.2665 11.9936 24.7021 11.791 24.9872 12.0311L32.3895 18.268C32.4884 18.3512 32.5454 18.4739 32.5454 18.6031L32.5454 45.5942C32.5454 45.9706 32.1022 46.1719 31.8187 45.9243L24.4164 39.4565Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7848 25.4653C10.6865 25.5486 10.6298 25.6709 10.6298 25.7998L10.6298 36.4911C10.6298 36.8644 11.0666 37.0668 11.3514 36.8255L16.1311 32.7771C16.2992 32.6347 16.5469 32.6393 16.7097 32.7878L21.0727 36.7675C21.3541 37.0242 21.8064 36.8245 21.8064 36.4437L21.8064 25.7901C21.8064 25.6668 21.7545 25.5493 21.6635 25.4662L16.7097 20.9476C16.5469 20.7992 16.2992 20.7946 16.1311 20.937L10.7848 25.4653Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3365_4240",
    x: 59.1632,
    y: 27.4774,
    width: 50.8954,
    height: 50.9145,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.04931
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.3425
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.85098 0 0 0 0 0.607843 0 0 0 0 0.0156863 0 0 0 0.49 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3365_4240"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3365_4240",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3365_4240",
    x: 235.383,
    y: 0.264552,
    width: 50.8954,
    height: 50.9145,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.04931
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.3425
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.85098 0 0 0 0 0.607843 0 0 0 0 0.0156863 0 0 0 0.49 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3365_4240"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3365_4240",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3365_4240",
    x: 18.9687,
    y: 1.18862,
    width: 50.8954,
    height: 50.9145,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.04931
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.3425
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.85098 0 0 0 0 0.607843 0 0 0 0 0.0156863 0 0 0 0.49 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3365_4240"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3365_4240",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3365_4240",
    x: 142.375,
    y: 20.1342,
    width: 50.8954,
    height: 50.9145,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.04931
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.3425
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.85098 0 0 0 0 0.607843 0 0 0 0 0.0156863 0 0 0 0.49 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3365_4240"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3365_4240",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapfooterlogo);
export default __webpack_public_path__ + "static/media/capfooterlogo.f62cc32c3aa2cf19a7d1e3e0226439fa.svg";
export { ForwardRef as ReactComponent };